<!-- 编辑问题 -->
<template>
  <div class="edit_problem">
    <div class="tabHead">
      <p :class="{'activeTabP':activeName == 1}" @click="clickTab(1)">{{ $t('workOrder.client_feedback') }}</p>
      <p :class="{'activeTabP':activeName == 2}" @click="clickTab(2)">{{ $t('workOrder.after_sales') }}</p>
      <p :class="{'activeTabP':activeName == 3}" @click="clickTab(3)">{{ $t('workOrder.quality_inspection') }}</p>
      <p :class="{'activeTabP':activeName == 4}" @click="clickTab(4)">{{ $t('workOrder.repair_processing') }}</p>
      <p :class="{'activeTabP':activeName == 5}" @click="clickTab(5)">{{ $t('workOrder.line_handling') }}</p>
      <p :class="{'activeTabP':activeName == 6}" @click="clickTab(6)">{{ $t('workOrder.pmc_handling') }}</p>
    </div>
    <div class="tabContent">
      <!-- {{ activeName }}{{ oldActiveIndex }}{{ clickActiveIndex }} -->
      <client-form v-if="activeName == 1" ref="client" :raw="form" @save="submitForm" @back="back" />
      <after-sales v-if="activeName == 2" ref="sales" :raw="form" @save="submitForm" @back="back" />
      <quality-inspection v-if="activeName == 3" ref="quality" :raw="form" :device-info="deviceInfo" @save="submitForm" @back="back" />
      <repair-form v-if="activeName == 4" ref="repair" :raw="form" @save="submitForm" @back="back" />
      <line-test v-if="activeName == 5" ref="line" :raw="form" @save="submitForm" @back="back" />
      <pmc-form v-if="activeName == 6" ref="pmc" :raw="form" @save="submitForm" @back="back" />
    </div>
  </div>
</template>

<script>
import ClientForm from './ClientForm.vue'
import { getChargerData, getById } from '@/api/workOrder'
import AfterSales from './AfterSales.vue'
import QualityInspection from './QualityInspection.vue'
import RepairForm from './RepairForm.vue'
import LineTest from './LineTest.vue'
import PmcForm from './PmcForm.vue'
import { isObjectValueEqual } from '@/utils'
export default {
  components: { ClientForm, AfterSales, QualityInspection, RepairForm, LineTest, PmcForm },
  props: ['id', 'current', 'popShow'],
  data() {
    return {
      form: {},
      activeName: 1,
      deviceInfo: {},
      oldActiveIndex: 1, // 上一次的tab index
      clickActiveIndex: 1, // 点击后的tab index
      isClickTab: false // 是否点击的tab
    }
  },

  watch: {
    id(val) {
      this.initProblem()
    },
    popShow(val) {
      if (val) this.initProblem()
    },
    current(val) {
      if (val) {
        this.oldActiveIndex = this.activeName = val
      }
    }
  },
  mounted() {
    this.initProblem()
  },
  methods: {
    clickTab(newIndex) {
      this.isClickTab = true
      console.log('newIndex', newIndex)
      this.clickActiveIndex = newIndex
      this.oldActiveIndex = this.activeName
      switch (this.oldActiveIndex) {
        case 1:this.$refs.client.clickCancel(); break
        case 2:this.$refs.sales.clickCancel(); break
        case 3:this.$refs.quality.clickCancel(); break
        case 4:this.$refs.repair.clickCancel(); break
        case 5:this.$refs.line.clickCancel(); break
        case 6:this.$refs.pmc.clickCancel(); break
      }
    },
    async back(form, stepObj, val) {
      console.log('back')
      // console.log('back',form,stepObj)
      if (val) this.isClickTab = false
      if (isObjectValueEqual(form, stepObj)) { // 没有未保存的数据
        console.log('返回')
        if (this.isClickTab) { // 点击的tab:切换
          this.activeName = this.clickActiveIndex
          return true
        } else { // 点击的取消：关掉弹窗
          this.$emit('cancel')
        }
      } else {
        await this.$confirm(this.$t('workOrder.dataNotSaved'), '', {// 数据未保存，点击确定后会丢失，是否继续
          confirmButtonText: this.$t('button.Confirm'), // '确定',
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning'
        }).then(() => {
          if (this.isClickTab) { // 点击的tab:切换
            this.activeName = this.clickActiveIndex
            return true
          } else { // 点击的取消：关掉弹窗
            this.$emit('cancel')
          }
        }).catch(() => {
          if (this.isClickTab) return false // 点击的tab:不切换
        })
      }
    },
    getData(sn) {
      getChargerData(sn).then(res => {
        console.log('设备信息：', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.deviceInfo = res.resultModel
          this.$storage.set('dtuDeviceInfo', res.resultModel || {})
        }
      })
    },
    changeCurrent(status) {
      if (status < 100) {
        this.activeName = this.oldActiveIndex = this.clickActiveIndex = status
      } else {
        this.activeName = this.oldActiveIndex = this.clickActiveIndex = 1
      }
    },
    initProblem() {
      if (!this.id) return
      getById(this.id).then(res => {
        console.log('问题主体：', res)
        if (res.resultCode == 1001) {
          this.form = res.resultModel
          this.getData(this.form.productSn)
          if (this.current) {
            this.activeName = this.oldActiveIndex = this.clickActiveIndex = this.current
          } else {
            this.changeCurrent(this.form.status)
          }
        }
      })
    },
    handleClick(val) {
      // console.log(val)
      this.isClickTab = true
      this.activeName = this.oldActiveIndex
    },
    cancel() {
      this.$emit('cancel')
    },
    submitForm(form) {
      this.$emit('save', form)
      this.changeCurrent(form.status)
      if (form.status >= 100) {
        this.cancel()
      }
      // setTimeout(() => {
      //   this.initProblem()
      // }, 2000);
    }
  }
}
</script>

<style lang='scss'>
.foot_btns {
  text-align: right;
}
.tabHead{
  display: flex;
  border-bottom: 1px solid #e4e8f0;
  p{
    // height: 30px;
    display: inline-block;
    padding-bottom: 10px;
    margin-right: 30px;
    cursor: pointer;
  }
  .activeTabP{
    border-bottom: 2px solid #1890ff;
    color:#1890ff;
  }
}
</style>
